var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.21 5.5425L7.035 2.25C7.58392 1.76288 8.29236 1.49387 9.02625 1.49387C9.76014 1.49387 10.4686 1.76288 11.0175 2.25L14.82 5.595C15.3542 6.06255 15.7819 6.63922 16.0743 7.28612C16.3667 7.93302 16.517 8.6351 16.515 9.345V13.5525C16.5012 14.3416 16.177 15.0935 15.6126 15.6452C15.0483 16.197 14.2892 16.5041 13.5 16.5H4.5C3.70435 16.5 2.94129 16.1839 2.37868 15.6213C1.81607 15.0587 1.5 14.2957 1.5 13.5V9.2475C1.50387 8.54364 1.65849 7.84877 1.95346 7.20967C2.24842 6.57058 2.67688 6.0021 3.21 5.5425Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.8875C8.85082 14.8875 8.70774 14.8282 8.60225 14.7227C8.49676 14.6173 8.4375 14.4742 8.4375 14.325V12.18C8.4375 12.0308 8.49676 11.8877 8.60225 11.7822C8.70774 11.6768 8.85082 11.6175 9 11.6175C9.14918 11.6175 9.29226 11.6768 9.39775 11.7822C9.50324 11.8877 9.5625 12.0308 9.5625 12.18V14.325C9.5625 14.4742 9.50324 14.6173 9.39775 14.7227C9.29226 14.8282 9.14918 14.8875 9 14.8875Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d6235db93f653a0fec6168b082296cfe.svg";
export { ForwardRef as ReactComponent };